"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllyKilledEventArgs = void 0;
const EventType_1 = require("../EventType");
class AllyKilledEventArgs {
    constructor(allyId) {
        this.allyId = allyId;
        this.__type = EventType_1.EventType.AllyKilled;
        this.__typeName = "AllyKilled";
    }
}
exports.AllyKilledEventArgs = AllyKilledEventArgs;
